<template>
  <section class="relative py-16 md:py-24 px-4 sm:px-6 md:px-10 overflow-hidden">
    <!-- CONTENT -->
    <div
      class="relative z-10 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center"
    >
      <!-- LEFT -->
      <div v-reveal class="text-center md:text-left">
        <h2 class="font-serif text-5xl md:text-6xl font-bold text-gray-900 leading-none">
          About Us
        </h2>
        <div class="mt-5 w-16 h-1 rounded-full bg-brand-red md:mx-0 mx-auto"></div>
        <p class="mt-5 text-gray-600 text-lg md:text-xl font-medium">
          আমাৰ পৰিচয় আৰু লক্ষ্য
        </p>
      </div>

      <!-- RIGHT -->
      <div v-reveal="{ delay: 0.15 }" class="card p-6 md:p-10">
        <!-- LANGUAGE SWITCH -->
        <div class="flex justify-end mb-6">
          <div class="inline-flex items-center gap-1 rounded-md bg-gray-100 p-1 text-sm font-semibold">
            <button
              @click="language = 'as'"
              :class="language === 'as' ? 'bg-white text-brand-red shadow-sm' : 'text-gray-500 hover:text-gray-800'"
              class="rounded px-4 py-1.5 transition-colors"
            >
              Assamese
            </button>
            <button
              @click="language = 'en'"
              :class="language === 'en' ? 'bg-white text-brand-red shadow-sm' : 'text-gray-500 hover:text-gray-800'"
              class="rounded px-4 py-1.5 transition-colors"
            >
              English
            </button>
          </div>
        </div>

        <!-- ASSAMESE CONTENT -->
        <p
          v-if="language === 'as'"
          class="prose-text"
        >
          সাংস্কৃতিক আলোচনী দাপোণ মূলত: অসমৰ সাংস্কৃতিক জগতৰ অতন্ত্ৰ প্ৰহৰী।
          অসমৰ সাংস্কৃতিক জগতৰ পুৰোধা ব্যক্তি সকলৰ জীৱন কীৰ্তি, তেওঁলোকৰ জীৱন
          বীক্ষা, অভিজ্ঞতা, তেওঁলোকে সাংস্কৃতিক জগতৰ নতুন প্ৰজন্মলৈ আগবঢ়োৱা
          পৰামৰ্শ, উপদেশ আদিৰ বিজ্ঞ ব্যক্তিৰ মননশীল ৰচনা সমূহ প্ৰকাশ কৰাটো আমাৰ
          লক্ষ্য। লগতে অসমৰ সাংস্কৃতিক বিষয় সমূহৰ গৱেষণামূলক ৰচনা প্ৰকাশো আমাৰ
          লক্ষ্য।
          <br /><br />
          আলোচনী খনৰ লগতে মাহেকীয়া সাংস্কৃতিক বাতৰি কাকত "দাপোণ" প্ৰকাশৰ দ্বাৰা
          জাতীয়, ৰাষ্ট্ৰীয়, আন্তৰাষ্ট্ৰীয় সাংস্কৃতিক অনুষ্ঠান, প্ৰতিষ্ঠানৰ বাতৰি
          প্ৰকাশৰ দ্বাৰা পাঠকৰ জ্ঞান সমৃদ্ধ কৰাৰ প্ৰয়াসো আমাৰ লক্ষ্য।
          <br /><br />
          সময়ৰ দাবীত আৰু পাঠকৰ ৰুচীৰ পৰিবৰ্তনৰ প্ৰতি লক্ষ্য ৰাখি কাকত আৰু আলোচনী
          দুয়োখনকে ডিজিটেল ৰূপত উপলব্ধ কৰিবলৈ
          <span class="font-semibold text-brand-red">
            www.sanskritirdapoon.in
          </span>
          ৱেব প’ৰ্টেল আৰম্ভ কৰা হৈছে।
        </p>

        <!-- ENGLISH CONTENT -->
        <div
          v-if="language === 'en'"
          class="prose-text"
        >
          <p>
            The Cultural Magazine <strong>Dapon</strong> is basically a sincere
            watchman of the cultural world of Assam. Our goal is to publish the
            thoughtful essays of the pioneers of Assam’s cultural world, their
            life experiences, advice, and required guidance for the new
            generation.
          </p>

          <p class="mt-4">
            Our aim is also to publish research-based articles by scholars on
            various cultural issues of Assam. We carefully observe cultural
            activities so that the traditional gestures, styles, and grammar of
            old Assam are not changed dramatically.
          </p>

          <p class="mt-4">
            This platform helps artists share their life journeys and activities.
            News of cultural programs, advertisements by cultural organizations,
            and related updates are also published here.
          </p>

          <p class="mt-4">
            Readers can download the Cultural Magazine
            <strong>Dapoon</strong> and the PDF version of the Cultural Newspaper
            <strong>Dapoon</strong>. These publications enrich knowledge about
            cultural events at the state, national, and international levels.
          </p>

          <p class="mt-4">
            In response to changing reader preferences and modern demands, the
            web portal
            <span class="font-semibold text-brand-red">
              www.sanskritirdapoon.in
            </span>
            has been launched to make both the newspaper and magazine available
            in digital form.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from "vue";

const language = ref("as"); // default Assamese
</script>
